'use client';
import { Box } from '@mui/material';
import ReactPlayer from 'react-player';

export default function VideoPlayer({ url }: { url: string }) {
  return (
    <Box sx={{ position: 'relative', paddingTop: '56.25%' }}>
      <ReactPlayer
        style={{ position: 'absolute', top: 0, left: 0 }}
        src={url}
        controls
        width="100%"
        height="100%"
      />
    </Box>
  );
}
